/*
 * SashiDo
 * All rights reserved.
 */
import AppsManager          from 'lib/AppsManager';
import DashboardView        from 'dashboard/DashboardView.react';
import SashiDoLogo          from 'components/SashiDoLogo/SashiDoLogo.react';
import Icon                 from 'components/Icon/Icon.react';
import ParseApp             from 'lib/ParseApp';
import React                from 'react';
import history from 'dashboard/history';
import PropTypes from 'prop-types';
import styles               from './DBRestore.scss';
import Popover              from 'components/Popover/Popover.react';


export default class DBRestore extends DashboardView {
  constructor() {
    super();

    this.state = {}
    this.reload_int = null;

    this.onCloseClick = this.onCloseClick.bind(this);
  }

  componentDidMount() {
    document.body.addEventListener('keydown', this.handleKey);

    const app = this.context.currentApp;

    if(app.params.restoring_backup) {
      this.reload_int = setInterval(() => {
        app.reload().then((app) => {

          const appReloaded = AppsManager.appsStoreUpdateApp(app);

          if(!appReloaded.params.restoring_backup) {
            history.push(`/products/apps/${appReloaded.slug}/backups/restore_history`);
          }
        });
      }, 15000)
    } else {
      history.push(`/products/apps/${app.slug}/backups/restore_history`);
    }
  }

  componentWillUnmount() {
    if(this.reload_int) {
      clearInterval(this.reload_int)
    }
  }

  handleKey(e) {
    var keyCode = e.keyCode || e.which;
    switch (keyCode) {
      case 27:
        this.onCloseClick();
        break;
    }
  }

  onCloseClick() {
    location.href = `/products/apps/`;
  }

  render() {
    let CancelIcon =
      !this.state.migrationLoading
        ?
          <a href='javascript:;' className={styles.iconClose} onClick={this.onCloseClick.bind(this)} >
            <Icon width={16} height={16} name={'icon-close'} />
          </a>
        : null

    return (
      <Popover modal={true}>
        <div className={[styles.migrate].join(' ')}>
          <div className={styles.showEffect}></div>

          <div className={styles.section}>
            <h1>Restoring Database for "{this.context.currentApp.name}"</h1>
            <div className={[styles.databases, styles.active].join(' ')}>
              <div className={[styles.db].join(' ')}>
                <div className={styles.ticker}>1</div>
                <div className={styles.ticker}>0</div>
                <div className={styles.ticker}>1</div>
                <div className={styles.ticker}>0</div>
              </div>
              <div className={styles.icon}>
                <h2>Backup DB</h2>
                <Icon name='icon-db' width={80} height={80} />
              </div>
              <div className={styles.icon}>
                <h2>Current DB</h2>
                <Icon name='icon-db' width={80} height={80} />
              </div>
            </div>
          </div>

          <SashiDoLogo />
          {CancelIcon}
        </div>
      </Popover>
    );
  }
}

DBRestore.contextTypes = {
  currentApp: PropTypes.instanceOf(ParseApp)
};

